export default __webpack_public_path__ + "static/media/leilabettcher.ed52ef7a.jpg";